<template>
    <svg></svg>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapActions } from 'vuex'
    
    export default {
      name: 'microCompetencyProgressPie',
      props: ['entityId', 'userId'],
      data: () => {
        return {}
      },

      mounted: function () {
        this.loadMicroCompetencySummary()
      },

      watch: {
        entityId (value) {
          if (value) {
            this.loadMicroCompetencySummary()
          }
        }
      },

      computed: {
        ...mapState({
          'microCompetency': state => state.course.mcSummaryForSelectedUser
        }),
    
        progress: function () {
          var total = this.microCompetency.childrenCount
          var failed = this.microCompetency.childrenFailedCount
          var completed = this.microCompetency.childrenCompleteCount
          var inProgress = this.microCompetency.childrenInProgressCount
          var inThePlan = (total - failed - completed - inProgress)
          var summary = []
          if (failed > 0) {
            summary.push({label: 'failed', value: failed})
          }
          if (completed > 0) {
            summary.push({label: 'completed', value: completed})
          }
          if (inProgress > 0) {
            summary.push({label: 'inProgress', value: inProgress})
          }
          if (inThePlan > 0) {
            summary.push({label: 'inThePlan', value: inThePlan})
          }
          return summary
        }
      },

      methods: {
        ...mapActions([
          'loadMicroCompetencyProgressForSelectedUser'
        ]),

        loadMicroCompetencySummary () {
          this.loadMicroCompetencyProgressForSelectedUser({entityId: this.entityId, userId: this.userId}).then((res) => {
            this.drawPieChart()
          })
        },

        drawPieChart () {
          var containerHeight = $('.progress-chart-conatiner').innerHeight()
          var svg = d3.select(this.$el).attr('width', containerHeight).attr('height', containerHeight)
          var margin = { top: 0, left: 10, bottom: 0, right: 0 }
          var chartWidth = containerHeight - (margin.left + margin.right)
          var chartHeight = containerHeight - (margin.top + margin.bottom)

          var chartLayer = svg
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`)

          var arc = d3.arc()
            .outerRadius(chartHeight / 2)
            .innerRadius(chartHeight / 4)

          var pie = chartLayer
            .append('g')
            .attr('transform', `translate(${chartWidth / 2}, ${chartHeight / 2})`)

          var colorScale = {
            'failed': '#bf1c13',
            'completed': '#8eb056',
            'inProgress': '#f0a656',
            'inThePlan': '#2dcafa'
          }

          const data = this.progress

          var arcs = d3.pie()
            .value(function (d) { return d.value }).sort(null)(data)

          var block = pie.selectAll('.arc').data(arcs)

          block.select('path')
            .attr('d', arc)

          var newBlock = block
            .enter()
            .append('g')
            .classed('arc', true)

          newBlock.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

          newBlock.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/app/course/components/MicroCompetencyProgressPie.vue